import React, {useEffect, useState} from 'react';
import { Button, Card, Row, Col, Rate } from "antd";
import { PhoneOutlined, SafetyOutlined, ThunderboltOutlined, DatabaseOutlined, 
         AppleOutlined, AndroidOutlined, LaptopOutlined, TabletOutlined } from '@ant-design/icons';
import {Link} from "react-router-dom";
import http from "../framework/http";

function Home() {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        loadBlogs();
    }, []);

    const loadBlogs = async () => {
        try {
            const res = await http.get("/blog/list", {params: {keyword: ""}});
            if (res.data?.code === 200) {
                // Get only the first 3 blogs
                setBlogs(res.data.data.slice(0, 3));
            }
        } catch (error) {
            console.error("Failed to load blogs:", error);
        }
    };

    const deviceCategories = [
        { name: 'Smartphones', icon: <PhoneOutlined />, link: '/category' },
        { name: 'Tablets', icon: <TabletOutlined />, link: '/category' },
        { name: 'Laptops', icon: <LaptopOutlined />, link: '/category' },
        { name: 'Wearables', icon: <AppleOutlined />, link: '/category' }
    ];

    const services = [
        {
            icon: <ThunderboltOutlined />,
            title: 'Rapid Repairs',
            description: 'Most repairs in store including iPhone screen repair take just 20-30 minutes!'
        },
        {
            icon: <SafetyOutlined />,
            title: 'FREE Diagnostics, No Fix No Fee',
            description: 'If we can\'t fix your device we do not charge and we offer FREE phone diagnostics'
        },
        {
            icon: <DatabaseOutlined />,
            title: 'Your Data Is Safe',
            description: 'We will never wipe your data unless absolutely necessary for repair and only with your consent'
        },
        {
            icon: <PhoneOutlined />,
            title: 'Free Phone Diagnostics',
            description: 'We do not charge to diagnose phone problems!'
        }
    ];

    const repairServices = [
        {
            title: 'Phone Repairs',
            description: 'Professional phone repair services for all major brands',
            image: require('../resources/images/dev_1.png'),
            link: '/contactUs'
        },
        {
            title: 'Laptop Repairs',
            description: 'Expert laptop repair and maintenance services',
            image: require('../resources/images/Macbook-PNG-Picture.png'),
            link: '/contactUs'
        },
        {
            title: 'Tablet Repairs',
            description: 'Fast and reliable tablet repair services',
            image: require('../resources/images/dev_3.png'),
            link: '/contactUs'
        }
    ];

    const brands = [
        { name: 'HTC', image: require('../resources/images/HTC_logo-copy-1.png') },
        { name: 'Samsung', image: require('../resources/images/samsung_logo_PNG13.png') },
        { name: 'Apple', image: require('../resources/images/apple_logo-1.png') },
        { name: 'Nexus', image: require('../resources/images/2000px-Nexus_7_Logo.svg_.png') },
        { name: 'Toshiba', image: require('../resources/images/TOSHIBA_Logo-1.png') },
        { name: 'Sony', image: require('../resources/images/sony_logo-1.png') }
    ];

    return (
        <div className="home-container">
            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-content">
                    <h1 className="hero-title">Ireland's Fastest Tech Repair Service</h1>
                    <p className="hero-subtitle">Phone repairs in just 20-30 minutes</p>
                    <div className="hero-buttons">
                        <Button size="large" href="/category" className="hero-btn-secondary">
                            View Services
                        </Button>
                    </div>
                </div>
            </section>

            {/* Device Categories */}
            <section className="device-section">
                <div className="container">
                    <h2 className="section-title">Choose your device to get started</h2>
                    <Row gutter={[24, 24]} justify="center">
                        {deviceCategories.map((device, index) => (
                            <Col xs={24} sm={12} md={6} key={index}>
                                <a href={device.link}>
                                    <Card className="device-card" hoverable>
                                        <div className="device-icon">{device.icon}</div>
                                        <h3>{device.name}</h3>
                                    </Card>
                                </a>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>

            {/* Services Highlights */}
            <section className="services-section">
                <div className="container">
                    <h2 className="section-title">Why Choose E-Tech?</h2>
                    <p className="section-subtitle">Ireland's Trusted Tech Repair Experts Since 2011</p>
                    <Row gutter={[32, 32]}>
                        {services.map((service, index) => (
                            <Col xs={24} sm={12} md={6} key={index}>
                                <Card className="service-card" bordered={false}>
                                    <div className="service-icon">{service.icon}</div>
                                    <h3 className="service-title">{service.title}</h3>
                                    <p className="service-description">{service.description}</p>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>

            {/* Repair Services Options */}
            <section className="repair-options-section">
                <div className="container">
                    <h2 className="section-title">Our Services</h2>
                    <p className="section-subtitle">What do you need to repair?</p>
                    <Row gutter={[32, 32]} justify="center">
                        {repairServices.map((repair, index) => (
                            <Col xs={24} sm={12} md={8} key={index}>
                                <Card className="repair-card" hoverable>
                                    <div className="repair-image">
                                        <img src={repair.image} alt={repair.title} />
                                    </div>
                                    <h3>{repair.title}</h3>
                                    <p>{repair.description}</p>
                                    <Button type="link" href={repair.link}>Enquire now →</Button>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </div>
            </section>

            {/* Location Map */}
            <section className="location-section">
                <div className="container">
                    <h2 className="section-title">Visit Our Store</h2>
                    <p className="section-subtitle">1 Ballinteer Rd, Dundrum, Dublin, D16 F5T7</p>
                    <div className="map-container">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2384.4726951726894!2d-6.248647!3d53.2897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48670e8c7c7c7c7d%3A0x7c7c7c7c7c7c7c7c!2s1%20Ballinteer%20Rd%2C%20Dundrum%2C%20Dublin%2C%20D16%20F5T7!5e0!3m2!1sen!2sie!4v1234567890"
                            width="100%"
                            height="450"
                            className="map-iframe"
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="E-Tech Store Location"
                        ></iframe>
                    </div>
                </div>
            </section>

            {/* Brands We Repair */}
            <section className="brands-section">
                <div className="container">
                    <h2 className="section-title">Brands We Repair</h2>
                    <div className="brands-grid">
                        {brands.map((brand, index) => (
                            <div key={index} className="brand-item">
                                <img src={brand.image} alt={brand.name} />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Latest News/Blogs Section */}
            <section className="home-blogs-section">
                <div className="container">
                    <h2 className="section-title">Latest News</h2>
                    <p className="section-subtitle">Stay updated with our latest tips and news</p>
                    <Row gutter={[32, 32]}>
                        {blogs.map((blog) => (
                            <Col xs={24} sm={12} md={8} key={blog.id}>
                                <Link to={`/blogs/${blog.id}`} className="blog-card-link">
                                    <Card className="home-blog-card" hoverable>
                                        <div className="home-blog-image">
                                            <img 
                                                src={blog.cover ? http.getUri() + blog.cover : http.getUri() + "images/default.png"} 
                                                alt={blog.title}
                                            />
                                        </div>
                                        <div className="home-blog-content">
                                            <h3 className="home-blog-title">{blog.title}</h3>
                                            <time className="home-blog-date">
                                                {new Date(blog.createdTime).toLocaleDateString('en-US', { 
                                                    year: 'numeric', 
                                                    month: 'short', 
                                                    day: 'numeric' 
                                                })}
                                            </time>
                                        </div>
                                    </Card>
                                </Link>
                            </Col>
                        ))}
                    </Row>
                    {blogs.length > 0 && (
                        <div style={{textAlign: 'center', marginTop: '32px'}}>
                            <Button size="large" href="/blogs" className="view-all-btn">
                                View All Articles →
                            </Button>
                        </div>
                    )}
                </div>
            </section>

            {/* Call to Action */}
            <section className="cta-section">
                <div className="container">
                    <h2>Ready to fix your device?</h2>
                    <p>Contact us for a quote or book your repair today</p>
                    <div className="cta-buttons">
                        <Button type="primary" size="large" href="/contactUs">
                            Contact Us
                        </Button>
                        <Button size="large" href="tel:01-534-1721" className="call-btn">
                            <PhoneOutlined /> 01-534-1721
                        </Button>
                    </div>
                    <p className="opening-hours">Opening Hours: Monday - Saturday 10am - 6:00pm</p>
                </div>
            </section>
        </div>
    );
}

export default Home;
